export default __webpack_public_path__ + "static/media/step-2-home.267189aa.png";